import React, { FC, ComponentProps } from "react";
import { cls } from "@wss/cls";

const ResultText: FC<ComponentProps<"p">> = ({
  className,
  children,
  ...rest
}) => (
  <p
    className={cls(
      "font-semibold text-lg leading-none [text-shadow:none] mb-0 text-gray-900",
      className,
    )}
    {...rest}
  >
    {children}
  </p>
);

export default ResultText;
